import type { GtmListIdTypeT } from '@vs-shop/schemas/gtm/list-types';
import { getListNameTypeFromId } from '@vs-shop/schemas/gtm/list-types';
import { Schema } from 'effect';

import { GtmSelectItemEventSchema } from '@vs-shop/schemas/gtm/select-item';

/**
 * Only the fields `createSelectItemPayloadFromProductCard` reads.
 *
 * The money is a plain `number`: the payload collapses an absent price to `0`
 * either way, and this type is also `ProductCardTracker`'s prop, which crosses
 * the RSC boundary. An `Option` there is a class instance React rejects (rule
 * 11), so a caller resolves the card with `resolveClientProductCardData`.
 */
export type HasSelectItemFields = {
  readonly code: string;
  readonly name: string;
  readonly price: number;
  readonly priceWithoutTax: number;
};

export const createSelectItemPayloadFromProductCard = (
  product: HasSelectItemFields,
  listType: GtmListIdTypeT
) => {
  const productPriceAmount = product.priceWithoutTax / 100;

  return Schema.decodeEffect(GtmSelectItemEventSchema)({
    event: 'select_item',
    ecommerce: {
      item_list_id: listType,
      item_list_name: getListNameTypeFromId(listType),
      items: [
        {
          id: product.code,
          name: product.name,
          price: productPriceAmount,
          price_with_tax: product.price / 100,
          quantity: 1,
        },
      ],
    },
  });
};
